export const ledgersEn = {
  // BEGIN Michael
  TOTAL_INCREASE: 'Total Increase',
  TOTAL_DECREASE: 'Total Decrease',
  FEE: 'Fee',
  ACCOUNTS_RECEIVABLE: 'Accounts Receivable',
  OFFSETTING: 'Offsetting',
  NOTES_INFORMATION: 'The notes in this field are applied for both main and offsetting entry',
  OFFSETTING_LINK_INFORMATION: 'Main and Offsetting are linked; deleting one removes both.',
  ADD_OFFSETTING_ENTRY: 'Add Offsetting Entry',
  BALANCED: 'Balanced',
  UNBALANCED: 'Unbalanced',
  OVER: 'Over',
  UNDER: 'Under',
  OFFSETTING_AMOUNT_MIRRORS_MAIN: 'Amount mirrors the main entry until a second entry is added.',
  OFFSETTING_ENTRIES: 'Offsetting Entries',
  DELETE_MANUAL_TRANSACTION_CONFIRMATION:
    'The main entry and its offsetting entries are linked — deleting this transaction removes all of them:',
  DELETE_MANUAL_TRANSACTION_WARNING: 'This action cannot be undone',
  CONFIRM_DELETE: 'Confirm Delete',
  ASSETS_AMOUNT_TYPE_INFO: 'Assets: Increase (Debit) / Decrease (Credit)',
  EXPENSE_AMOUNT_TYPE_INFO: 'Expense: Increase (Debit) / Decrease (Credit)',
  REVENUE_AMOUNT_TYPE_INFO: 'Revenue: Increase (Credit) / Decrease (Debit)',
  LIABILITY_AMOUNT_TYPE_INFO: 'Liability: Increase (Credit) / Decrease (Debit)',
  AR_LEDGER_AMOUNT_LEDGER_TYPE: 'AR Ledger (Open AR) -> Assets',
  FUEL_ADVANCE_LEDGER_AMOUNT_TYPE: 'Fuel Advance Ledger -> Assets',
  ACCRUED_FEES_LEDGER_AMOUNT_TYPE: 'Accrued Fees Ledger -> Assets',
  ACCRUED_INTEREST_LEDGER_AMOUNT_TYPE: 'Accrued Interest Ledger -> Assets',
  AP_BANK_ACCOUNT_LEDGER_AMOUNT_TYPE: 'AP Bank Account Ledger -> Assets',
  AR_BANK_ACCOUNT_LEDGER_AMOUNT_TYPE: 'AR Bank Account Ledger -> Assets',
  FEES_LEDGER_AMOUNT_TYPE: 'Fees Ledger -> Revenue',
  ESCROW_LEDGER_AMOUNT_TYPE: 'Escrow Ledger -> Liability',
  CASH_RESERVE_LEDGER_AMOUNT_TYPE: 'Cash Reserve Ledger -> Liability',
  LIABILITY_LEDGER_AMOUNT_TYPE: 'Liability Ledger -> Liability',
  UNAPPLIED_LEDGER_AMOUNT_TYPE: 'Unapplied Ledger -> Liability',
  MAIN_ENTRY: 'Main Entry',
  // END Michael
  // BEGIN Fco
  ACCRUED_FEE: 'Accrued Fees',
  ACCRUED_INTEREST: 'Accrued Interest',
  FEE_ESCROW: 'Fee Escrow',
  INCREASE: 'Increase',
  DECREASE: 'Decrease',
  LEDGER_AR: 'AR',
  FACTOR_BALANCE: 'Factor Balance',
  CLIENT_BALANCE: 'Client Balance',
  RELATION_BALANCE: 'Relation Balance',
  TRANSACTION_CODE: 'Transaction Code',
  COPY_TRANSACTION_CODE: 'Copy transaction code',
  TRANSACTION_CODE_COPIED: 'Transaction code copied',
  // END Fco
  // BEGIN Fabian
  DATE_START: 'Date Start',
  DATE_END: 'Date End',
  DESCRIPTION: 'Description',
  CREDIT: 'Credit',
  DEBIT: 'Debit',
  OPEN_AR: 'Open AR',
  NFE: 'NFE',
  TITLE_TYPE_AR: '{title} Ledgers',
  LEDGER: 'Ledger',
  LEDGERS: 'Ledgers',
  LIABILITY: 'Liability',
  INCREASE_OR_DECREASE: 'Increase or Decrease',
  LEDGER_TYPE: 'Ledger Type',
  CREATE_MANUAL_TRANSACTION: 'Create Manual Transaction',
  OFFSETTING_ENTRY: 'Offsetting Entry',
  MANUAL_TRANSACTION: 'Manual Transaction',
  MANUAL_TRANSACTION_DELETE: 'Manual transaction deleted successfully',
  MANUAL_TRANSACTION_CREATED_SUCCESSFULLY: 'Manual transaction created successfully',
  ACTIVE: 'Active',
  WRITE_OFFS_LEDGER_AMOUNT_TYPE: 'Write Offs Ledger -> Expense',
  // END Fabian
  //BEGIN Esteban
  GL_CODE: 'GL Code',
  GROUP_CODE: 'Group Code',
  PAYMENT_BATCH: 'Payment Batch',
  FUEL_ADVANCE: 'Fuel Advance',
  //END Esteban
  // FC2-3976: Additional Fee GL code dropdown group headers
  GL_CODE_GROUP_SYSTEM: 'System',
  GL_CODE_GROUP_PURCHASE_FEE_CHILD: '1001 Child',
  GL_CODE_GROUP_ADDITIONAL_FEE_CHILD: '1009 Child',

  // BEGIN Patricio
  PAYMENT_TRANSACTION_REF: 'Payment Ref',
  LEDGER_EXPORT_CONFIRMATION: `You are trying to export {totalRows} rows of data, this action will take some time to complete, proceed?`,
  LEDGER_EXPORT: 'Export Ledger Data',
  OFFSETTING_SWITCH_DESCRIPTION: 'Enable or disable the offsetting row inside the disbursement csv',
  OVER_ADVANCE_LEDGER_AMOUNT_TYPE: 'Over Advance Ledger -> Over Advance',
  OVER_ADVANCE_AMOUNT_TYPE_INFO: 'Over Advance: Increase (Debit) / Decrease (Credit)',
  //END Patricio
  // Suffix on GL-code dropdown option labels (e.g. "Name - 1234 (Custom)") — full text,
  // no space constraint there, so this is intentionally not abbreviated like the badge.
  CUSTOM_GL_CODE_OPTION_LABEL: 'Custom',
  CUSTOM_GL_CODE_INDICATOR_TOOLTIP: 'Custom GL Code',
}

export const ledgersEs: typeof ledgersEn = {
  // BEGIN Michael
  TOTAL_INCREASE: 'Total Incremento',
  TOTAL_DECREASE: 'Total Decremento',
  FEE: 'Comisión',
  ACCOUNTS_RECEIVABLE: 'Cuentas por Cobrar',
  OFFSETTING: 'Compensación',
  NOTES_INFORMATION: 'Las notas en este campo se aplican tanto para la entrada principal como para la compensatoria',
  OFFSETTING_LINK_INFORMATION: 'Principal y Compensatoria están vinculados; eliminar uno elimina ambos.',
  ADD_OFFSETTING_ENTRY: 'Agregar Entrada de Compensación',
  BALANCED: 'Balanceado',
  UNBALANCED: 'Desbalanceado',
  OVER: 'Excedente',
  UNDER: 'Faltante',
  OFFSETTING_AMOUNT_MIRRORS_MAIN: 'El monto refleja la entrada principal hasta que se agregue una segunda entrada.',
  OFFSETTING_ENTRIES: 'Entradas de Compensación',
  DELETE_MANUAL_TRANSACTION_CONFIRMATION:
    'La entrada principal y sus entradas de compensación están vinculadas — al eliminar esta transacción se eliminarán todas:',
  DELETE_MANUAL_TRANSACTION_WARNING: 'Esta acción no se puede deshacer',
  CONFIRM_DELETE: 'Confirm Delete',
  ASSETS_AMOUNT_TYPE_INFO: 'Activos: Incremento (Débito) / Decremento (Crédito)',
  EXPENSE_AMOUNT_TYPE_INFO: 'Gasto: Incremento (Débito) / Decremento (Crédito)',
  REVENUE_AMOUNT_TYPE_INFO: 'Ingresos: Incremento (Crédito) / Decremento (Débito)',
  LIABILITY_AMOUNT_TYPE_INFO: 'Pasivo: Incremento (Crédito) / Decremento (Débito)',
  AR_LEDGER_AMOUNT_LEDGER_TYPE: 'Libro de Cuentas por Cobrar (Open AR) -> Activos',
  FUEL_ADVANCE_LEDGER_AMOUNT_TYPE: 'Libro de Avance por Combustible -> Activos',
  ACCRUED_FEES_LEDGER_AMOUNT_TYPE: 'Libro de Comisiones Acumuladas -> Activos',
  ACCRUED_INTEREST_LEDGER_AMOUNT_TYPE: 'Libro de Intereses Acumulados -> Activos',
  AP_BANK_ACCOUNT_LEDGER_AMOUNT_TYPE: 'Libro de Cuenta Bancaria de AP -> Activos',
  AR_BANK_ACCOUNT_LEDGER_AMOUNT_TYPE: 'Libro de Cuenta Bancaria de AR -> Activos',
  FEES_LEDGER_AMOUNT_TYPE: 'Libro de Comisiones -> Ingresos',
  ESCROW_LEDGER_AMOUNT_TYPE: 'Libro de Fideicomiso -> Pasivo',
  CASH_RESERVE_LEDGER_AMOUNT_TYPE: 'Libro de Reserva de Efectivo -> Pasivo',
  LIABILITY_LEDGER_AMOUNT_TYPE: 'Libro de Pasivo -> Pasivo',
  UNAPPLIED_LEDGER_AMOUNT_TYPE: 'Libro de No Aplicado -> Pasivo',
  MAIN_ENTRY: 'Entrada Principal',
  // END Michael
  // BEGIN Fco
  ACCRUED_FEE: 'Comisiones Acumuladas',
  ACCRUED_INTEREST: 'Intereses Acumulados',
  FEE_ESCROW: 'Fee Escrow',
  INCREASE: 'Incremento',
  DECREASE: 'Decremento',
  LEDGER_AR: 'AR',
  FACTOR_BALANCE: 'Balance Factor',
  CLIENT_BALANCE: 'Balance Cliente',
  RELATION_BALANCE: 'Balance Relación',
  TRANSACTION_CODE: 'Código de Transacción',
  COPY_TRANSACTION_CODE: 'Copiar código de transacción',
  TRANSACTION_CODE_COPIED: 'Código de transacción copiado',
  // END Fco
  // BEGIN Fabian
  DATE_START: 'Fecha Inicio',
  DATE_END: 'Fecha fin',
  DESCRIPTION: 'Descripción',
  CREDIT: 'Crédito',
  DEBIT: 'Débito',
  OPEN_AR: 'Open AR',
  NFE: 'NFE',
  TITLE_TYPE_AR: 'Libros {title}',
  LEDGERS: 'Libros',
  LEDGER: 'Libro',
  LIABILITY: 'Pasivo',
  INCREASE_OR_DECREASE: 'Débito o Crédito',
  LEDGER_TYPE: 'Tipo de Libro',
  CREATE_MANUAL_TRANSACTION: 'Crear transacción manual',
  OFFSETTING_ENTRY: 'Entrada de Compensación',
  MANUAL_TRANSACTION: 'Transacción Manual',
  MANUAL_TRANSACTION_DELETE: 'Transacción manual eliminada con éxito',
  MANUAL_TRANSACTION_CREATED_SUCCESSFULLY: 'Transacción manual creada con éxito',
  ACTIVE: 'Activo',
  WRITE_OFFS_LEDGER_AMOUNT_TYPE: 'Libro de Cancelaciones -> Gasto',
  // END Fabian
  //BEGIN Esteban
  GL_CODE: 'GL Code',
  GROUP_CODE: 'Group Code',
  PAYMENT_BATCH: 'Payment Batch',
  FUEL_ADVANCE: 'Avance por Combustible',
  //END Esteban
  // FC2-3976: Additional Fee GL code dropdown group headers
  GL_CODE_GROUP_SYSTEM: 'Sistema',
  GL_CODE_GROUP_PURCHASE_FEE_CHILD: 'Hijos de 1001',
  GL_CODE_GROUP_ADDITIONAL_FEE_CHILD: 'Hijos de 1009',

  // BEGIN Patricio
  PAYMENT_TRANSACTION_REF: 'Referencia Pago',
  LEDGER_EXPORT_CONFIRMATION: `Estás intentando exportar {totalRows} filas de datos, esta acción tomará algo de tiempo en completarse, ¿deseas continuar?`,
  LEDGER_EXPORT: 'Exportar Datos de Libro',
  OFFSETTING_SWITCH_DESCRIPTION:
    'Habilita o deshabilita la creación de la fila de compensación dentro del csv de desembolsos',
  OVER_ADVANCE_LEDGER_AMOUNT_TYPE: 'Libro de Sobre Avance -> Sobre Avance',
  OVER_ADVANCE_AMOUNT_TYPE_INFO: 'Sobre Avance: Incremento (Débito) / Decremento (Crédito)',
  //END Patricio
  // Suffix on GL-code dropdown option labels (e.g. "Nombre - 1234 (Personalizado)") — full
  // text, no space constraint there, so this stays unabbreviated like the badge.
  CUSTOM_GL_CODE_OPTION_LABEL: 'Personalizado',
  CUSTOM_GL_CODE_INDICATOR_TOOLTIP: 'Código GL personalizado',
}
